export const getEmail = obj => {
  return findEmailNode(obj)?.value
}

export const setEmail = (obj, email) => {
  const emailNode = findEmailNode(obj)
  if (emailNode) {
    emailNode.value = email
  }
}

const findEmailNode = obj => {
  if (Array.isArray(obj)) {
    for (let item of obj) {
      const result = findEmailNode(item)
      if (result) {
        return result
      }
    }
  } else if (obj && typeof obj === 'object') {
    if (obj.type === 'Email') {
      return obj
    }
    for (let value of Object.values(obj)) {
      const result = findEmailNode(value)
      if (result) {
        return result
      }
    }
  }
  return null
}

export const getKeywords = card => {
  const allTags = getAvailableTags(card)
  return card.conditionalItems?.map(tagId => allTags[tagId]) || []
}

/**
 * Extracts and returns a dictionary of available tags from the given card's sections.
 *
 * @param {Object} card - The card object containing sections.
 * @returns {Object} A dictionary where the keys are tag IDs and the values are tag names.
 */
const getAvailableTags = card => {
  const conditionalTags = {}
  card.sections.forEach(sec => {
    sec.setTags?.forEach(tag => {
      conditionalTags[tag.id] = tag.name
    })

    sec.assessment?.forEach(assess => {
      assess?.responses.forEach(resp => {
        resp.tags?.forEach(tag => {
          conditionalTags[tag.id] = tag.name
        })
      })
    })
  })

  return conditionalTags
}

export const lockVisibleHeaders = (card, headers) => {
  let headersIndex = 0
  card.sections.forEach(sec => {
    if (sec.type === 'Separator') {
      if (!headers || headersIndex < headers) {
        sec.isLocked = true
      }
      headersIndex++
    }
  })
}

export const saveDispatcher = {
  saveCallback: () => {},
}

export const loadDispatcher = {
  loadCallback: undefined,
}
